// extracted by mini-css-extract-plugin
export default {"TextLinkContainer":"ClickableTextButton_TextLinkContainer__DRwZL","Text":"ClickableTextButton_Text__irZi-","ClickableText":"ClickableTextButton_ClickableText__IaUyo"};